import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { getResponseMessage } from "../../../../utils";
import { TRole } from "../../../../interfaces/users";
import { editSettingGPT } from "../../../../crud/users.crud";

export const useEditSettingGPT = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingEdit, setLoading] = useState(false);
  const [successEdit, setSuccessEdit] = useState(false);
  const intl = useIntl();

  const fetchSettingEdit = useCallback(
    async (values: {
      type: "main_promt" | "promt" | "dialog_opening" | "avatar" | "model" | "model_2";
      locale?: string;
      user_role?: TRole;
      value?: string;
      avatar?: File;
      disableSuccess?: boolean;
    }) => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const { type, locale, user_role, value, avatar, disableSuccess } = values;
      const data = new FormData();
      data.append("type", type);
      locale && data.append("locale", locale);
      user_role && data.append("user_role", user_role);
      value && data.append("value", value);
      avatar && data.append("avatar", avatar);
      setLoading(true);
      editSettingGPT(data)
        .then(() => {
          setSuccessEdit(true);
          !disableSuccess && enqueueSnackbar(intl.formatMessage({ id: "PROMOCODE.SETTINGS.SUCCESS" }), { variant: "success" });
        })
        .catch(e => {
          enqueueSnackbar(`${intl.formatMessage({ id: "NOTISTACK.ERRORS.ERROR" })} ${getResponseMessage(e)}`);
        })
        .finally(() => {
          setTimeout(() => {
            setSuccessEdit(false);
          }, 200);
          setLoading(false);
        });
    },
    []
  );

  return {
    fetchSettingEdit,
    loadingEdit,
    successEdit,
  };
};
